<template>
  <div class="filtrate-container custom-side-filter">
    <transition name="van-fade">
      <div v-show="visible" class="mask" @click="close"></div>
    </transition>

    <transition name="van-slide-right">
      <div class="side wrap" v-show="visible">
        <div class="main">
          <!-- <van-cell
            title="校区"
            is-link
            :value="campusText"
            @click="chooseCampus"
          />
          <van-cell
            title="课程"
            is-link
            value-class="van-ellipsis"
            :value="curriculumText"
            @click="chooseCourse"
          />
          <van-cell
            title="课时包"
            is-link
            value-class="van-ellipsis"
            :value="params.universalCardInfoId?params.universalCard.name:''"
            @click="chooseCard"
          />
          <van-cell
            title="班级"
            is-link
            value-class="van-ellipsis"
            :value="classText"
            @click="chooseClass"
          /> -->
          <van-cell
            title="创建人"
            is-link
            :value-class="['van-ellipsis', createTeacher ? 'selected':'']"
            :value="createTeacher || '请选择'"
            @click="chooseCreateTeacher"
          />
          <van-cell
            title="业绩归属人"
            is-link            
            :value-class="['van-ellipsis', teacherText ? 'selected':'']"
            :value="teacherText || '请选择'"
            @click="chooseTeacher"
          />
          <div class="three-a-row">
            <div class="nav-title">下次补交日期</div>
            <div class="date-box">
              <input-date-range :start="params.nextPayStartTime" :end="params.nextPayEndTime" :type="2" @change="chooseCalendar"></input-date-range>
            </div>
          </div>
          <div class="three-a-row">
            <div class="nav-title">创建时间</div>
            <div class="date-box">
              <input-date-range :start="params.orderCreateStartTime" :end="params.orderCreateEndTime" @change="chooseCalendar2"></input-date-range>
            </div>
          </div>
          <div class="three-a-row">
            <div class="nav-title">上次提醒时间</div>
            <div class="date-box">
              <input-date-range :start="params.lastNoticeStartTime" :end="params.lastNoticeEndTime" @change="chooseCalendar3"></input-date-range>
            </div>
          </div>
          <div class="three-a-row" style="margin-top: calc(var(--gap) * 8)">
            <div class="nav-title">提醒状态</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of noticeStatusList" :key="item.id">
                <div
                  class="item-nav"
                  :class="{ active: params.noticeStatus.indexOf(item.id) > -1 }"
                  @click="triggerStatus(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-row class="footer" gutter="12">
          <van-col span="12">
            <van-button block square round @click="reset"> 重置 </van-button>
          </van-col>
          <van-col span="12">
            <van-button block square round type="primary" @click="confirm">
              确定
            </van-button>
          </van-col>
        </van-row>
      </div>
    </transition>
  </div>
</template>

<script>
import InputDateRange from '@x3/vue/comp/input-date-range.vue';

let defaultParams = {
  // 创建人
  orderCreatePersonIdList: [],
  orderCreatePersonLists: [],
  // 业绩归属人
  belongerIdList: [],
  belongerLists: [],
  // 下次补交日期
  nextPayStartTime: '',
  nextPayEndTime: '',
  // 创建时间
  orderCreateStartTime: '',
  orderCreateEndTime: '',
  // 上次提醒时间
  lastNoticeStartTime: '',
  lastNoticeEndTime: '',
  noticeStatus: [],
};

export default {
  name: "feeOweFiltrate",
  components: {
    InputDateRange
  },
  data() {
    return {
      visible: false,
      tagList: [],
      params: JSON.parse(JSON.stringify(defaultParams)),
      noticeStatusList: [
        { name: "已提醒", id: 1 },
        { name: "未提醒", id: 0 },
      ],
      config: {},
    };
  },
  computed: {
    createTeacher: function() {
      let tcs = this.params.orderCreatePersonLists,
        text = "";
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个老师`;
      }
      return text;
    },
    teacherText: function() {
      let tcs = this.params.belongerLists,
        text = "";
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个老师`;
      }
      return text;
    }
  },
  methods: {
    prevInit() {
      if (!this.$route.meta._resolve) {
        setTimeout(() => {
          this.$router.back();
        }, 0);
      } else {
        let opts = this.$route.meta.options || {};
        this._resolve = this.$route.meta._resolve;
        this._reject = this.$route.meta._reject;
        if (opts.config) {
          this.config = Object.assign(this.config, opts.config);
        }
        if (opts.params) {
          let params = JSON.parse(JSON.stringify(opts.params));
          this.params = Object.assign(this.params, params);
        }

        setTimeout(() => {
          this.visible = true;
        }, 0);
      }
    },
    // 选择创建人
    async chooseCreateTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.orderCreatePersonIdList,
        list: this.params.orderCreatePersonLists
      });
      this.params.orderCreatePersonIdList = res.ids;
      this.params.orderCreatePersonLists = res.list;
    },
    // 选择业绩归属人
    async chooseTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.belongerIdList,
        list: this.params.belongerLists,
      });

      this.params.belongerIdList = res.ids;
      this.params.belongerLists = res.list;
    },
    // 处理提醒状态
    triggerStatus(item) {
      let i = this.params.noticeStatus.indexOf(item.id);
      if (i === -1) {
        this.params.noticeStatus.push(item.id);
      } else {
        this.params.noticeStatus.splice(i, 1);
      }
    },
    async chooseCalendar(ret) {
      this.params.nextPayStartTime = ret.startDate
      this.params.nextPayEndTime = ret.endDate
    },
    async chooseCalendar2(ret) {
      this.params.orderCreateStartTime = ret.startDate
      this.params.orderCreateEndTime = ret.endDate
    },
    async chooseCalendar3(ret) {
      this.params.lastNoticeStartTime = ret.startDate, 'yyyy-MM-dd'
      this.params.lastNoticeEndTime = ret.endDate, 'yyyy-MM-dd'
    },
    // 重置
    async reset() {
      this.params = JSON.parse(JSON.stringify(defaultParams));
    },
    render() {
      this.$api.tagList().then((res) => {
        this.tagList = res.data;
      });
    },
    doneAnima() {
      this.$router.back();
      return new Promise((rsv) => {
        setTimeout(() => {
          rsv();
        }, 100);
      });
    },
    async close() {
      await this.doneAnima();
    },
    async confirm() {
      await this.doneAnima();
      let params = JSON.parse(JSON.stringify(this.params));
      this._resolve(
        JSON.parse(
          JSON.stringify({
            params,
          })
        )
      );
    },
  },
  created() {
    this.prevInit();
    this.render();
  },
  watch: {
    "$vxRoute.vx_action": function (nv, ov) {
      if (nv == "vx-out") {
        this.visible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filtrate-container {
  background: transparent;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(var(--black-rgb), 0.7);
    z-index: 1;
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: var(--x3-slide-left);
    background: var(--g1);
    z-index: 2;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    font-size: var(--fs-md);
    color: var(--g8);
    background: var(--white);
    .main {
      flex: 1;
      overflow-y: auto;
      .nav-wrapper {
        margin-left: calc(var(--gap) * 16);
        .nav-title {
          padding: calc(var(--gap) * 8) calc(var(--gap) * 16)
            calc(var(--gap) * 16) 0;
          font-size:var(--fs-md);
          line-height:var(--lh-md);
        }
      }

    }
  }
}
</style>